import { Button, Form, message, Input, Col, Row, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import managerApis from 'api/managerApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat, onlyDateFormat } from 'helpers/dateTimeHelper';

export default function ListManagersPage() {

  const [managers, setManagers] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();

  async function fetchManagers(params={}) {
    setIsFetching(true);
    try {
      const res = await managerApis.listing(params);
      if (res.code === 200) {
        setManagers(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchManagers()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchManagers(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchManagers(params)
  };

  const handleDelete = async (managerId) => {
    try {
      const res = await managerApis.deleteManager(managerId);
      if (res.code === 200) {
        message.success('Xóa thành công');
        fetchManagers();
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'ID',
      width: '15rem',
      dataIndex: 'id',
      key: 'id',
      sorter: true,
    },
    {
      title: 'Email',
      width: '20rem',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
    },
    {
      title: 'Role',
      width: '15rem',
      dataIndex: 'role',
      key: 'role',
      sorter: true,
    },
    {
      title: 'Created At',
      width: '15rem',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (created_at) => {
        return fullDateTimeFormat(created_at);
      }
    },
    {
      title: 'Updated At',
      width: '15rem',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      render: (updated_at) => {
        return fullDateTimeFormat(updated_at);
      }
    },
    {
      title: 'Chức năng',
      width: '15rem',
      render: (record) => (
        <>
          <p>
            <Button type="primary" style={{ marginRight: '8px' }}>
              <Link to={`/managers/${record.id}`}>Cập nhật</Link>
            </Button>
            <Popconfirm
              title="Bạn có chắc muốn xóa manager này?"
              onConfirm={() => handleDelete(record.id)}
              okText="Có"
              cancelText="Không"
            >
              <Button type="primary" danger>
                Xóa
              </Button>
            </Popconfirm>
          </p>
        </>
      )
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả Managers"
        pageHeaderExtras={[
          <Button type="primary">
            <Link to={'/managers/new'}>Thêm mới</Link>
          </Button>
        ]}
      />
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='email'
                label='Email'
              >
                <Input placeholder="Tìm theo email" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='role'
                label='Role'
              >
                <Input placeholder="Tìm theo role" />
              </Form.Item>
            </Col>
            <Col
              span={8}
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          columns={columns}
          dataSource={managers}
          rowKey="id"
          loading={isFetching}
          pagination={{
            current: paginate.page,
            pageSize: paginate.limit,
            total: paginate.total,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            position: [bottom]
          }}
          onChange={onChangeTable}
        />
      </ContentRow>
    </>
  );
}
